<template>
  <!--
      作者：zhuchangtao
      时间：2021-03-30
      描述：题库-添加题目
    -->
  <div class="product-add pb50">
   <!--添加题目-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">编辑题目</div>
      <el-form-item label="题目内容" prop="title"><el-input type="textarea" v-model="form.title" placeholder="请输入题目内容" class="max-w460"></el-input></el-form-item>
      <el-form-item label="题目类型：">
        <el-radio-group v-model="form.type" disabled>
          <el-radio :label="10">单选</el-radio>
          <el-radio :label="20">多选</el-radio>
        </el-radio-group>
      </el-form-item>
      <div>
        <el-button size="small" class="el-icon-circle-plus" @click="onAddOption">添加选项</el-button>
      </div>
      <div v-for="(ddd,index) in counter">

          <el-form-item :label="ddd.value" >
              <el-input style="width:180px" v-model="ddd.option" placeholder="请输入题目答案选项" autocomplete="off" required prop="option"></el-input>


          </el-form-item>
      </div>

      <el-form-item label="题目答案：" v-if="form.type == 10">
        <el-radio-group v-model="answer" >
          <el-radio :label="item.value" :key='item.value' v-for="item in counter">{{item.value}}</el-radio>

        </el-radio-group>

      </el-form-item>

      <el-form-item label="题目答案：" v-if="form.type == 20">



          <el-checkbox-group v-model="checkboxanswer" size="small">
            <el-checkbox :label="item.value" :key='item.value' v-for="item in counter" border></el-checkbox>

          </el-checkbox-group>
      </el-form-item>

      <!-- <el-form-item label="答案解析" >
        <el-input type="textarea" v-model="form.parse" placeholder="请输入答案解析" class="max-w460"></el-input>
      </el-form-item> -->
      <el-form-item label="获得积分"><el-input type="number" v-model="form.points" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <el-form-item label="排序"><el-input type="number" v-model="form.sort" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

  </div>
</template>

<script>
import TopicApi from '@/api/topic.js';

export default {
  components: {

  },
  data() {
    return {

      /*form表单数据*/
      form: {
        title: '',
        sort:1,
        type:10,
        option:'',
        parse:'',
        points:''

      },
      answer:'',
      checkboxanswer:[],
      counter:[{'option':'','value':'A'}],
      array:['A',"B","C","D","E","F"],
      loading: false,
      /*验证规则*/
      rules: {
        title: [{ required: true, message: '请输入题目', trigger: 'blur' }],
        option: [{ required: true, message: '请输入选项', trigger: 'blur' }],

      }
    };
  },
  created() {
    /*获取列表*/
    this.getCategoryList();
  },
  methods: {

    /*获取资料类别*/
    getCategoryList() {
      let self = this;
      let Params = {};
      const params = self.$route.query.topic_id;
      TopicApi.toEdittopic({topic_id: params},true).then(res => {
          self.form = res.data.model;

          self.counter = res.data.model.option;
          if(res.data.model.type.value ==10){
            self.answer = res.data.model.answer;
          }else if(res.data.model.type.value ==20){
            self.checkboxanswer = res.data.model.answer.split(',');
          }
          self.form.type =res.data.model.type.value;
          self.loading = false;
        })
        .catch(error => {});
    },


    /*添加资料*/
    onSubmit() {
      let self = this;
      let form = self.form;
      if(form.type == 10){
        if(self.answer == ''){
          self.$message({
            message: "请选择答案",
            type: 'error'
          });
          return false;
        }
        form.answer = self.answer;
      }else if(form.type == 20){
        if(self.checkboxanswer == ''){
          self.$message({
            message: "请选择答案",
            type: 'error'
          });
          return false;
        }
        form.answer = self.checkboxanswer;
      }
      if(self.counter.length <2){
        self.$message({
          message: "选项不能少于两条",
          type: 'error'
        });
        return false;
      }
      let stat = false;
      self.counter.forEach((item,index)=>{

        if(item.option == ''){
          stat = true;
        }
      })
      if(stat){
        self.$message({
          message: "选项不能为空",
          type: 'error'
        });
        return false;
      }
      form.option = JSON.stringify(self.counter);
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          TopicApi.edittopic(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.$router.push('/topic/topic/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    onAddOption(){
      if(this.counter.length == 6){
        this.$message('最多只能添加6个选项');
        return false;
      }
      this.counter.push({'option':'','value':''})
      let self = this;
      this.counter.forEach((item,index)=>{

        item.value=self.array[index]
      })

    },
    /*删除商品图片*/
    deleteOption(index) {

      this.counter.splice(index, 1);
    },
    /*取消添加，返回资料列表*/
    cancelFunc() {
      this.$router.push({
        path: '/topic/topic/index'
      });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>



// WEBPACK FOOTER //
// src/views/topic/topic/edit.vue